import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IntegrationSettings } from '../../models/integrations.model';

@Component({
    selector: 'app-integration-tab-container',
    templateUrl: './integration-tab-container.component.html',
    styleUrls: ['./integration-tab-container.component.scss']
})
export class IntegrationTabContainerComponent implements OnInit {
    @Input() integrationSettings: IntegrationSettings;
    @Input() initialTabIndex: number = 0;
    @Output() settingsSaved = new EventEmitter<void>();

    selectedTabIndex: number = 0;

    ngOnInit(): void {
        this.selectedTabIndex = this.initialTabIndex;
    }

    get integrationType(): string {
        return this.integrationSettings.integration.id;
    }

    get isIcims(): boolean {
        return this.integrationType === 'iCIMS' || this.integrationType === 'IcimsInbound';
    }

    get isPayworks(): boolean {
        return this.integrationType === 'Payworks';
    }

    get isPayzaar(): boolean {
        return this.integrationType === 'Payzaar';
    }

    get isAdp(): boolean {
        return this.integrationType === 'Adp';
    }

    get showMappingsTab(): boolean {
        return this.integrationType !== 'Payzaar'
            && this.integrationType !== 'IcimsInbound';
    }
}
